import SukuButtonRow from "./buttonRow"
import SukuButton from "./button"
import SukuColorRow from "./colorRow"
import SukuColorButton from "./colorBtn"
import Suku3dNotify from './3dNotify'
import SukuPayment from './payment'

export default class SukuControls extends HTMLElement {
  static get observedAttributes() {
    return ['selected']
  }

  constructor() {
    super()

    this.className = 'w-1/2 p-10 border-0 border-l border-black border-solid mobile:w-full mobile:p-3 mobile:border-l-0 mobile:bg-white mobile:border-t mobile:pb-12'
    this.setAttribute('button-text', 'Add to cart')

    this.selected = this.getAttribute('selected').replace(/'/g, '"')
    this.location = this.getAttribute('location')
    this.payment
    // this.notify

    this.addEventListener('update', this.handleUpdate.bind(this))
    this.addEventListener('color', this.handleColor.bind(this))
  }

  handleColor(evt) {
    const selected = JSON.parse(this.selected.replace(/'/g, '"'))
    
    const category = selected.category
    const size = selected.size
    const color = selected.color
    
    const option = window.__SUKU_Options.find(item => {
      return item.color.replaceAll(' ', '_').toLowerCase() === color && category === item.category
    })

    const sizeIndex = typeof option !== 'undefined' ? option.product.variants.findIndex(item => item.options.some(optionSize => optionSize.replaceAll(' ', '_').toLowerCase() === size)) : -1

    if (typeof option === 'undefined' || (sizeIndex < 0 && category !== 'pillowcases')) {
      this.price.textContent = 'Unavailable with those options'
      this.colorPrice.textContent = 'Unavailable with those options'
      this.payment.setAttribute('available', false)
      this.payment.setAttribute('show', false)
      // this.notify.setAttribute('show', false)

      return
    }

    let variant = null
    const rawSize = size.replaceAll('_', ' ')
    if (category === 'pillowcases') {
      variant = option.product.variants.find(va => va.title.includes(this.location))
    } else {
      const variants = option.product.variants.filter(va => {
        return va.options.findIndex(opt => opt.toLowerCase() === rawSize) > -1
      })

      variant = variants.find(va => va.title.includes(this.location))
    }

    if (variant.available) {
      this.price.innerHTML = variant.priceMoney
      this.colorPrice.innerHTML = `<span class="mr-3">${evt.detail.name}</span> ${variant.priceMoney}`  

      this.payment.setAttribute('variant-id', variant.id)
      this.payment.setAttribute('available', true)
      this.payment.setAttribute('show', true)
      this.payment.setAttribute('button-text', 'Add to Cart')
      // this.notify.setAttribute('show', false)
    } else {
      this.price.textContent = `Sold Out`
      this.colorPrice.textContent = `Sold Out`

      this.payment.setAttribute('available', false)
      this.payment.setAttribute('show', true)
      this.payment.setAttribute('button-text', 'Sold Out')

      // this.notify.setAttribute('product', option.product.title)
      // this.notify.setAttribute('variant', variant.title)
      // this.notify.setAttribute('show', true)
    }

    // update note
    if (window.__SUKU.settings.hasOwnProperty(category) && window.__SUKU.settings[category].note) {
      this.payment.setAttribute('note-text', window.__SUKU.settings[category].note) 
      this.payment.setAttribute('note-show', true)
    } else {
      this.payment.setAttribute('note-text', '') 
      this.payment.setAttribute('note-show', false)
    }
  }

  handleUpdate(evt) {
    let selected = JSON.parse(this.selected.replace(/'/g, '"'))

    selected[evt.detail.key] = evt.detail.value

    this.setAttribute('selected', JSON.stringify(selected))

    if (evt.detail.key !== 'color') {
      this.payment.setAttribute('available', false)
      this.payment.setAttribute('show', false)
      // this.notify.setAttribute('show', false)
      this.price.textContent = ''
      this.colorPrice.textContent = ''

      // clear all button active states
      const buttons = this.querySelectorAll('suku-color-button')
      Array.from(buttons).forEach(button => {
        button.setAttribute('active', false)
      })
    }
  }

  connectedCallback() {
    setTimeout(() => {
      this.price = this.querySelector('p[data-price]')
      this.colorPrice = this.querySelector('p[data-color-price]')
    }, 50)

    // categories, sizes, colors 
    const categories = window.__SUKU_Options.reduce((arr, option) => {
      const index = arr.findIndex(item => item === option.category)
      if (index < 0) {
        arr.push(option.category)
      }

      return arr
    }, [])

    const sizes = window.__SUKU_Options.reduce((arr, option) => {
      option.product.variants.forEach(variant => {
        if (option.product.options[0] === 'Size') {
          const size = variant.options[0]

          const index = arr.findIndex(item => item === size)
          if (index < 0 && size !== 'Default Title') {
            arr.push(variant.options[0])
          }
        }
      })
      return arr
    }, [])
    sizes.push('Pillowcase Set')

    const colors = window.__SUKU_Options.reduce((arr, option) => {
      const index = arr.findIndex(item => item === option.color)
      if (index < 0) {
        arr.push(option.color)
      }
      return arr
    }, [])

    // web components, markup
    let categoryRow, sizeRow
    customElements.whenDefined('suku-button-row').then(() => {
      categoryRow = new SukuButtonRow()  
      categoryRow.setAttribute('type', 'category')
      categoryRow.setAttribute('active', 'true')
      categoryRow.setAttribute('selected', '')
      categoryRow.setAttribute('key', '')
      categoryRow.setAttribute('filter', '')
      categoryRow.setAttribute('relation', 'size')
      categoryRow.setAttribute('byline', 'Select Product')

      sizeRow = new SukuButtonRow()
      sizeRow.setAttribute('type', 'size')
      sizeRow.setAttribute('active', 'false')
      sizeRow.setAttribute('selected', '')
      sizeRow.setAttribute('key', '')
      sizeRow.setAttribute('filter', '')
      sizeRow.setAttribute('relation', 'color')
      sizeRow.setAttribute('byline', 'Select Size')

      this.appendChild(categoryRow)
      this.appendChild(sizeRow)
    })

    customElements.whenDefined('suku-button').then(() => {
      categories.map(category => {
        const name = window.__SUKU.settings.hasOwnProperty(category) ? window.__SUKU.settings[category].name : category
        const button = new SukuButton()

        button.setAttribute('active', false)
        button.setAttribute('show', true)
        button.setAttribute('name', name)
        button.setAttribute('type', 'category')
        button.setAttribute('key', category.replaceAll(' ', '_').toLowerCase())

        categoryRow.appendChild(button)
      })

      sizes.map(size => {
        const name = size
        const button = new SukuButton()

        button.setAttribute('active', false)
        button.setAttribute('show', true)
        button.setAttribute('name', name)
        button.setAttribute('type', 'size')
        button.setAttribute('key', size.replaceAll(' ', '_').toLowerCase())

        sizeRow.appendChild(button)
      })
    })

    let colorRow
    customElements.whenDefined('suku-color-row').then(() => {
      colorRow = new SukuColorRow()
      colorRow.setAttribute('type', 'color')
      colorRow.setAttribute('active', 'false')
      colorRow.setAttribute('selected', '')
      colorRow.setAttribute('filter', '')
      colorRow.setAttribute('key', '')
      colorRow.setAttribute('byline', 'Select Colour')
      
      this.appendChild(colorRow)
    })

    customElements.whenDefined('suku-color-button').then(() => {
      colors.map(color => {
        const matched = window.__SUKU_Options.find(option => option.color === color)

        if (matched) {
          const button = new SukuColorButton()
          button.setAttribute('available', 'true')
          button.setAttribute('active', 'false')
          button.setAttribute('name', matched.color)
          button.setAttribute('color', matched.color.replaceAll(' ', '_').toLowerCase())
          button.setAttribute('image', matched.button.image)
          button.setAttribute('texture', matched.texture)
          button.setAttribute('texture-style', matched.textureStyle)
          button.setAttribute('texture-alt', matched.textureAlt)
          button.setAttribute('border', matched.button.border ? matched.button.border : false)

          colorRow.appendChild(button)
        }
      })
    })

    customElements.whenDefined('suku-payment').then(() => {
      const payment = new SukuPayment()
      payment.setAttribute('show', false)
      payment.setAttribute('available', false)
      payment.setAttribute('variant-id', '')
      payment.setAttribute('note-text', '')
      payment.setAttribute('note-show', 'false')
      payment.setAttribute('button-text', 'Add to Cart')

      this.appendChild(payment)

      this.payment = payment
    })
    
    /*
    customElements.whenDefined('suku-3d-notify').then(() => {
      const notify = new Suku3dNotify()
      notify.setAttribute('show', false)
      notify.setAttribute('available', false)

      this.appendChild(notify)

      this.notify = notify
    })
    */
  }

  attributeChangedCallback(name, current, value) {
    if (current === value) {
      return
    }

    switch (name) {
      case 'selected' : 
        this.selected = value
        break
    }
  }
}

customElements.define('suku-controls', SukuControls)
